"use client";

import { Mail } from "lucide-react";

import NimbleWordmarkLogo from "@/app/(discover)/components/nimble-wordmark-logo";

function AuthHeaderContainer({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex flex-col items-center text-center space-y-2 sm:space-y-3 mb-4 sm:mb-6">
      {children}
    </div>
  );
}

function AuthHeaderContent({ children }: { children: React.ReactNode }) {
  return <div className="space-y-1">{children}</div>;
}

function AuthHeaderTitle({ children }: { children: React.ReactNode }) {
  return <h2 className="text-lg font-semibold text-foreground">{children}</h2>;
}

export function CredentialsHeader({ title }: { title: string }) {
  return (
    <AuthHeaderContainer>
      <NimbleWordmarkLogo className="h-7 sm:h-8 w-auto" />
      <AuthHeaderContent>
        <AuthHeaderTitle>{title}</AuthHeaderTitle>
      </AuthHeaderContent>
    </AuthHeaderContainer>
  );
}

export function OTPHeader({ email }: { email: string }) {
  return (
    <AuthHeaderContainer>
      <div className="w-10 h-10 sm:w-12 sm:h-12 bg-secondary/10 rounded-full flex items-center justify-center">
        <Mail className="w-5 h-5 sm:w-6 sm:h-6 text-secondary" />
      </div>
      <AuthHeaderContent>
        <AuthHeaderTitle>Check your email</AuthHeaderTitle>
        <p className="text-sm text-muted-foreground">
          We sent a 6-digit code to{" "}
          <span className="font-medium text-secondary">{email}</span>
        </p>
      </AuthHeaderContent>
    </AuthHeaderContainer>
  );
}
